export default __webpack_public_path__ + "static/media/xlsx.bdccd850.svg";